import {Kind} from 'graphql';

import type {ArgumentNode, FieldNode, SelectionSetNode} from 'graphql';

export function extractVariableNamesFromArguments(
  args: ReadonlyArray<ArgumentNode> | undefined,
): string[] {
  if (!args) {
    return [];
  }

  const variableNames: string[] = [];

  args.forEach((argument: ArgumentNode) => {
    if (argument.value.kind === Kind.VARIABLE) {
      variableNames.push(argument.value.name.value);
    }
  });

  return variableNames;
}

export function extractVariableNamesFromTopLevelField(
  field: FieldNode,
): ReadonlyArray<string> {
  const variableNames: string[] = [];

  // Extract variables used as arguments to top level field
  variableNames.push(...extractVariableNamesFromArguments(field.arguments));

  // Extract variables used in directive on to top level field
  if (field.directives) {
    field.directives.forEach((directive) => {
      variableNames.push(
        ...extractVariableNamesFromArguments(directive.arguments),
      );
    });
  }

  return variableNames;
}

export function extractFragmentNamesFromSelectionSet(
  selectionSet: SelectionSetNode,
): ReadonlyArray<string> {
  const fragmentNames = new Set<string>();

  function extractFragments(selectionSet: SelectionSetNode): void {
    for (const selection of selectionSet.selections) {
      if (selection.kind === Kind.FRAGMENT_SPREAD) {
        fragmentNames.add(selection.name.value);
      } else if (selection.kind === Kind.FIELD && selection.selectionSet) {
        extractFragments(selection.selectionSet);
      } else if (
        selection.kind === Kind.INLINE_FRAGMENT &&
        selection.selectionSet
      ) {
        extractFragments(selection.selectionSet);
      }
    }
  }

  extractFragments(selectionSet);

  return Array.from(fragmentNames);
}
